import { AppState } from 'app/store';

export const getThemePaletteTypeSelector = (state: AppState) =>
  state.settings.paletteType;

export const getThemeModeSelector = (state: AppState) =>
  state.settings.themeMode;

export const getSettingsSelector = (state: AppState) => state.settings.settings;

export const getScrollIsMounted = (state: AppState) =>
  state.settings.scrollIsMounted;

export const getShowMobileNotification = (state: AppState) =>
  state.settings.showMobileNotification;

export const getSiderbarSettings = (state: AppState) => state.settings.sidebar;

export const getCoWriterBarSettings = (state: AppState) =>
  state.settings.coWriterBar;

export const getProfileBarSettings = (state: AppState) =>
  state.settings.profileBar;

export const getSongChatBarSettings = (state: AppState) =>
  state.settings.songChatBar;
